import type { ComponentPublicInstance } from 'vue'
import type { Props } from '../../../ui/confirm-dialog/index.vue'
import { createApp } from 'vue'
import BaseConfirmDialog from '../../../ui/confirm-dialog/index.vue'

export function useConfirmDialog(args: Props) {
  const root = document.createElement('div')
  document.body.appendChild(root)

  const app = createApp(BaseConfirmDialog, {
    title: args.title,
    text: args.text,
    actions: args.actions,
    actionsOptions: args.actionsOptions,
    onClickResolve: destroy,
    onClickReject: destroy,
  })
  const instance = app.mount(root) as ComponentPublicInstance<
    typeof BaseConfirmDialog
  >

  function open(): Promise<boolean> {
    return instance.open()
  }

  function destroy() {
    app.unmount()
    document.body.removeChild(root)
  }

  return {
    open,
  }
}
